import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video",
  "use": "icon-video-usage",
  "viewBox": "0 0 16 13",
  "content": "<symbol viewBox=\"0 0 16 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-video\">\n<rect x=\"0.5\" y=\"1\" width=\"15\" height=\"11\" rx=\"3.5\" stroke=\"#B1B1B4\" />\n<path d=\"M10.3951 5.75449C10.8398 6.15203 10.8398 6.84797 10.3951 7.24551L8.05203 9.34026C7.40777 9.91624 6.38554 9.45895 6.38554 8.59475L6.38554 4.40525C6.38554 3.54105 7.40777 3.08376 8.05203 3.65974L10.3951 5.75449Z\" fill=\"#B1B1B4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol